(function () {

    "use strict";
    angular
        .module('harriApp')
        .directive('hDayDatePicker', ['$timeout', function ($timeout) {
            return {
                templateUrl: '../scripts/global-directives/html/h_day_date_picker.ng.html',
                restrict: 'E',
                scope: {
                    day: '=?ngModel',
                    onDaySelected: '&',
                    placement:'<',
	                dateFormat: '@?dateFormat',
                    datadogActionName: '<?',
                    minDate:'<',
                    maxDate:'<',
                    isReadonly: '<'
                },
                link: function (scope, element, attrs) {

                    //Move day to next
                    scope.addDay = function () {
                        scope.day = scope.day.clone().add(1, 'day');
                        //Fire select event
                        scope.onDaySelected({day: scope.day});
                    };

                    //Move day to prev
                    scope.subtractDay = function () {
                        scope.day = scope.day.clone().subtract(1, 'day');
                        //Fire select event
                        scope.onDaySelected({day: scope.day});
                    };

                    /**
                     * Open the date picker when input is pressed
                     */
                    scope.openDatepicker = function () {
                        element.find('input[name="selectedDate"]').focus();
                    };

                    /**
                     * update days on date change
                     */
                    scope.changeDatePicker = function () {
                        scope.day.setHours(12);

                        //Fire select event
                        scope.onDaySelected({day: scope.day});
                    };

                    scope.onBlur = function (event) {
                        scope.$emit('dayDatePickerInputBlured', event);
                    };

                    scope.onFocus = function(event) {
                        scope.$emit('dayDatePickerInputFocused', event);
                    };

                    scope.isMaxDateEqualSelectedDay = function () {
                        if (scope.maxDate && scope.day) {
                            return moment(scope.day).isSameOrAfter(moment(scope.maxDate), 'day');
                        }
                        return false;
                    };

                    scope.isMinDateEqualSelectedDay = function () {
                        if (scope.minDate && scope.day) {
                            return moment(scope.day).isSameOrBefore(moment(scope.minDate), 'day');
                        }
                        return false;
                    };

                }
            };
        }])

})();
